module.exports = __webpack_public_path__ + "static/media/Statua_055.f4b0d523.jpg";